module.exports = __webpack_public_path__ + "static/media/mobile-product-bg-1.46ce1990.svg";